import React from "react";
import { Button, Modal } from "@mui/joy";
import FailureIcon from "../../assets/svgs/failureIcon.svg";

interface PaymentFailureProps {
  open: boolean;
  onRetry: () => void;
  onCancel: () => void;
  message?: string;
  title?: string;
  subtitle?: string;
  retryButtonText?: string;
  cancelButtonText?: string;
}

const PaymentFailure: React.FC<PaymentFailureProps> = ({
  open,
  onRetry,
  onCancel,
  message,
  title = "Payment Failed!",
  subtitle,
  retryButtonText = "Retry Payment",
  cancelButtonText = "Cancel",
}) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="payment-failure-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiModal-backdrop": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "none",
        },
      }}
    >
      <div className="bg-white rounded-xl p-6 w-[90%] max-w-[390px] text-center">
        <div className="flex justify-center mb-4">
          <div className="w-12 h-12 flex items-center justify-center">
            <img src={FailureIcon} alt="Failure" />
          </div>
        </div>

        <h3 className="text-xl font-semibold mb-2">{title}</h3>

        <p className="text-gray-500 text-base">{subtitle || message}</p>

        <Button
          variant="solid"
          fullWidth
          onClick={onRetry}
          sx={{
            height: 48,
            marginTop: "24px",
          }}
        >
          {retryButtonText}
        </Button>

        <Button
          variant="plain"
          color="neutral"
          fullWidth
          onClick={onCancel}
          sx={{
            height: 48,
            fontSize: "16px",
            fontWeight: 600,
            color: "#2E2D7E",
            backgroundColor: "#F4F4F4",
            marginTop: "24px",
            "&:hover": { backgroundColor: "#F5F5F5" },
          }}
        >
          {cancelButtonText}
        </Button>
      </div>
    </Modal>
  );
};

export default PaymentFailure;
